import { ReservationRequestDto } from "@/api/generated/generatedTypes";
import { Accordion, Stack, Text } from "@mantine/core";
import { StagedRequestItem } from "./StagedRequestItem";
import { StagingGroup } from "./types";

interface StagedRequestsListProps {
  stagedRequests: ReservationRequestDto[];
  stagingGroup: StagingGroup;
  onRemoveRequest: (requestId: number) => void;
  showPersonalityTest: { [key: number]: boolean };
  onTogglePersonalityTest: (id: number) => void;
  showReservationPreferences: { [key: number]: boolean };
  onToggleReservationPreferences: (id: number) => void;
}

export const StagedRequestsList = ({
  stagedRequests,
  stagingGroup,
  onRemoveRequest,
  showPersonalityTest,
  onTogglePersonalityTest,
  showReservationPreferences,
  onToggleReservationPreferences,
}: StagedRequestsListProps) => {
  return (
    <Stack gap="xs">
      <Text c="black" size="sm" fw={700}>
        배정된 요청 ({stagedRequests.length}명)
      </Text>
      {stagedRequests.length > 0 ? (
        <Accordion multiple onClick={(e) => e.stopPropagation()}>
          {stagedRequests.map((req) => (
            <StagedRequestItem
              key={req.id}
              request={req}
              stagingGroup={stagingGroup}
              onRemove={onRemoveRequest}
              showPersonalityTest={showPersonalityTest[req.id] || false}
              onTogglePersonalityTest={() => onTogglePersonalityTest(req.id)}
              showReservationPreferences={showReservationPreferences[req.id] || false}
              onToggleReservationPreferences={() => onToggleReservationPreferences(req.id)}
            />
          ))}
        </Accordion>
      ) : (
        <Text c="gray" size="sm">
          배정된 요청이 없습니다
        </Text>
      )}
    </Stack>
  );
};
